import React from 'react';
import PropTypes from 'prop-types';
import { withApi } from '@tencent/react-aio';
import _ from 'lodash';
import { connect } from 'react-redux';
import * as ActionTypes from '@/stores/sale/actions';
import { Select } from '@tencent/spaui';
import { getAgencyList } from '@/pages/leads/highSeas/AssignToAgency/api';

class AgencySelect extends React.Component {
  static propTypes = {
    webApi: PropTypes.object.isRequired,
    agencyId: PropTypes.number,
    agencyList: PropTypes.arrayOf(PropTypes.object).isRequired,
    onChange: PropTypes.func.isRequired,
    selectableAgecnyIds: PropTypes.arrayOf(PropTypes.number),
  }

  state = {
    searchValue: '',
    agencyList: [],
  }

  componentDidMount() {
    const { agencyList } = this.state;
    if (_.isEmpty(agencyList)) {
      this.setState({ loading: true });
      getAgencyList()
        .then((res) => {
          if (!_.isEmpty(res)) {
            this.setState({ agencyList: res, loading: false });
            return;
          }
          this.setState({ agencyList: [], loading: false });
        })
        .catch((err) => {
          this.setState({ agencyList: [], loading: false });
        });
    }
  }

  handleSearch = (event, value) => {
    this.setState({
      searchValue: value,
    });
  }

  render() {
    const { agencyId, onChange, selectableAgecnyIds, disabled } = this.props;
    const { agencyList, searchValue, loading  } = this.state;
    let selectableAgecnyList = agencyList;
    if (selectableAgecnyIds) {
      selectableAgecnyList = _.isEmpty(selectableAgecnyIds) ? [] : _.filter(agencyList, (agency) => !!_.find(selectableAgecnyIds, (id) => id === agency.agencyId));
    }

    const data = _.map(selectableAgecnyList, (agency) => {
      const label = `${agency.agencyName}-${agency.agencyId}`;
      return { value: agency.agencyId, label, disabled, tip: label };
    });

    return <Select style={{ minWidth: 300 }} loading={loading} value={agencyId} data={data} onChange={onChange} search searchValue={searchValue} onSearch={this.handleSearch} />;
  }
}

function mapStateToProps(state, ownProps) {
  return {
    agencyList: _.map(state.agencyList.items, (agencyId) => state.agencyRepo[agencyId]),
  };
}

export default withApi(connect(mapStateToProps)(AgencySelect));
